import { Header, Footer } from "components";
import { useSEO } from "hooks";
/**
 * A Layout component
 */
export default function Layout({
  children,
  headerLinks,
  footerLinks,
  page,
  transparentHeader = false,
  lightLogo = false,
}) {
  const SEO = useSEO({ page });
  return (
    <>
      <Header
        links={headerLinks}
        transparent={transparentHeader}
        lightLogo={lightLogo}
      ></Header>
      {SEO}
      <main style={{ contain: 'paint'}}>{children}</main>
      <Footer links={footerLinks}></Footer>
    </>
  );
}
